import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import * as actions from './labelConfig.actions'

const initialState = {
    labelTreeList: [],
    childLabelList: {
        data: [],
        page: 1,
        pageSize: '',
        totalNumber: '',
    },
    rightTreeList: [],
    selectNode: {
        id: '',
        name: ''
    },
    appFields: {
        act: {},
        app: {},
        amount: {},
        ruleBody: [],
    },
    labelInfo: {},
    getlabelInfoLoading: false,
    labelFormInfo: {},
    addLabelInfo: {},
    renderSwich: {type: '', swich: false},
    ruleList: []
}

export type LabelConfigState = {
    labelTreeList: any[]
    childLabelList: any
    rightTreeList: any[]
    selectNode: any
    appFields: any,
    labelInfo: any,
    getlabelInfoLoading: boolean,
    labelFormInfo: any,
    addLabelInfo: any
    renderSwich: any
    ruleList: any[]
}

export default handleActions<LabelConfigState>({
    [actions.RECEIVE_TREE_LIST]: (state, {payload}) =>{
        return update(state, {
            labelTreeList: {$set: (payload as any)}
        })
    },
    [actions.RECEIVE_TREE_LABEL_LIST]: (state, {payload}) =>{
        return update(state, {
            labelTreeList: {$push: (payload as any)}
        })
    },
    [actions.RECEIVE_RIGHT_TREE_LIST]: (state, {payload}) =>{
        return update(state, {
            rightTreeList: {$set: (payload as any)}
        })
    },
    [actions.SET_SELECT_NODE]: (state, {payload}) =>{
        return update(state, {
            selectNode: {$set: (payload as any)}
        })
    },
    [actions.SET_APP_FIELDS]: (state, {payload}) =>{
        return update(state, {
            appFields: {$set: (payload as any)}
        })
    },
    [actions.GET_LABEL_INFO]: (state, {payload}) =>{
        return update(state, {
            labelInfo: {$set: (payload as any)}
        })
    },
    [actions.GET_LABEL_INFO_LOADING]: (state, {payload}) =>{
        return update(state, {
            getlabelInfoLoading: {$set: (payload as any)}
        })
    },
    [actions.PUSH_LABEL_FORM_INFO]:(state, {payload}) =>{
        return update(state, {
            labelFormInfo: {$merge: (payload as any)}
        })
    },
    [actions.RECEIVE_RULE_LIST]:(state, {payload}) =>{
        return update(state, {
            ruleList: {$set: (payload as any).data}
        })
    },
    [actions.ADD_LABEL_INFO]:(state, {payload}) =>{
        return update(state, {
            addLabelInfo: {$set: (payload as any)}
        })
    },
    [actions.RECEIVE_RENDER_SWICH]:(state, {payload}) =>{
        return update(state, {
            renderSwich: {$set: (payload as any)}
        })
    }
}, initialState)
